import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Row, Col } from "antd";
import axios from "axios";
import SummaryApi from '../../common/index';
import { Link, useNavigate } from "react-router-dom";
import "../../Styles/UserStylings/SignUp.css";
 
const { Title } = Typography;
 
const Signup = () => {
  const [form] = Form.useForm();
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const navigate = useNavigate();
 
const sendOtp = async () => {
  const mobile_number = form.getFieldValue("mobile");
  if (!mobile_number) return message.warning("Please enter mobile number first");
  try {
    setLoading(true);
    const res = await axios.post(SummaryApi.sendOtp.url, { mobile_number });

    if (res.data.success) {
      message.success("OTP sent successfully!");
      setOtpSent(true);
      setResendTimer(30); // ⏱ start 30s cooldown before allowing resend

      // ⏱ countdown timer logic
      const timerInterval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      message.error(res.data.message || "Failed to send OTP");
    }
  } catch (err) {
    console.error("❌ Send OTP error:", err);
    const errorMessage =
      err.response?.data?.message ||
      err.message ||
      "Something went wrong while sending OTP";
    message.error(errorMessage);
  } finally {
    setLoading(false);
  }
};

 
  // Verify OTP before registration
  const verifyOtpBeforeSignup = async () => {
    const mobile_number = form.getFieldValue("mobile");
    const otp = form.getFieldValue("otp");
    if (!otp) return message.warning("Enter OTP");
    try {
      setLoading(true);
      const res = await axios.post(SummaryApi.verifySignup.url, { mobile_number, otp });
      if (res.data.success) {
        message.success("OTP verified successfully!");
        setOtpVerified(true); // allow registration now
      } else {
        message.error(res.data.message || "OTP verification failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong while verifying OTP");
    } finally {
      setLoading(false);
    }
  };
 
  // Signup after OTP verification
  const onFinish = async () => {
    if (!otpVerified) return message.warning("Please verify OTP before registering");
    const name = form.getFieldValue("name");
    const email = form.getFieldValue("email");
    const mobile = form.getFieldValue("mobile");
    const password = form.getFieldValue("password");
    if (!name || !email || !mobile || !password) {
      return message.warning("All fields are required");
    }
    try {
      setLoading(true);
      const response = await axios.post(SummaryApi.signup.url, {
        name,
        email,
        mobile_number: mobile,
        password
      });
      if (response.data.success) {
        message.success("Signup successful! Please login.");
        form.resetFields();
        setOtpSent(false);
        setOtpVerified(false);
        if (response.data.token) localStorage.setItem("token", response.data.token);
        navigate("/login");
      } else {
        message.error(response.data.message || "Signup failed");
      }
    } catch (error) {
      console.error("Signup error:", error);
      message.error(error.response?.data?.message || "Something went wrong. Try again!");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="user-signup-wrapper">
      <div className="user-signup-card">
        <Title level={3} className="user-signup-title">Create Account</Title>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="user-signup-form"
        >
          <Form.Item label="Full Name" name="name" rules={[{ required: true, message: "Enter your name" }]}>
            <Input placeholder="Enter your full name" className="user-signup-input"/>
          </Form.Item>
 
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Enter your email" },
              { type: "email", message: "Enter a valid email" }
            ]}
          >
            <Input placeholder="Enter your email" className="user-signup-input"/>
          </Form.Item>
 
         {/*
  ✅ Mobile Number input — only Send OTP button here
*/}
{/* ✅ Mobile Number input with Send OTP / Verified button */}
<Form.Item
  label="Mobile Number"
  name="mobile"
  rules={[
    { required: true, message: "Enter your mobile number" },
    { pattern: /^\d{10}$/, message: "Mobile number must be exactly 10 digits" },
  ]}
>
  <Row gutter={8} className="mobile-row">
    <Col span={16}>
      <Input
        placeholder="Enter mobile number"
        maxLength={10}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, "");
          if (value.length <= 10) {
            form.setFieldsValue({ mobile: value });
          }
        }}
        className="user-signup-input"
        disabled={otpVerified} // ✅ lock number after verification
      />
    </Col>
    <Col span={8}>
     <Button
  type={otpVerified ? "default" : "primary"}
  block
  onClick={!otpVerified ? sendOtp : undefined}
  loading={loading}
  className="user-signup-otp-btn"
  disabled={otpVerified || resendTimer > 0}
  style={{
    backgroundColor: otpVerified ? "#75AD4B" : undefined,
    color: otpVerified ? "#D3D5D9" : undefined,
    borderColor: otpVerified ? "#75AD4B" : undefined,
  }}
>
  {otpVerified
    ? "Verified ✓"
    : resendTimer > 0
    ? `Resend in ${resendTimer}s`
    : otpSent
    ? "Resend OTP"
    : "Send OTP"}
</Button>

    </Col>
  </Row>
</Form.Item>

{/* ✅ OTP input with Verify button beside it */}
{otpSent && !otpVerified && (
  <Form.Item
    label="OTP"
    name="otp"
    rules={[{ required: true, message: "Enter OTP" }]}
  >
    <Row gutter={8} className="otp-row">
      <Col span={16}>
        <Input placeholder="Enter OTP" className="user-signup-input" />
      </Col>
      <Col span={8}>
        <Button
          type="primary"
          block
          onClick={verifyOtpBeforeSignup}
          loading={loading}
          className="user-signup-otp-btn"
        >
          Verify OTP
        </Button>
      </Col>
    </Row>
  </Form.Item>
)}
     
 
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: "Enter your password" },
              { min: 6, message: "Password must be at least 6 characters" }
            ]}
          >
            <Input.Password placeholder="Enter password" className="user-signup-input"/>
          </Form.Item>
 
          <Form.Item>
            <Row gutter={10}>
              <Col span={24}>
                <Button type="primary" htmlType="submit" block className="user-signup-btn-blue">
                  Register
                </Button>
              </Col>
            </Row>
          </Form.Item>
 
          <p className="user-signup-footer">
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </Form>
      </div>
    </div>
  );
};
 
export default Signup;